<template>
  <div class="card">
    <div v-if="titulo" class="card-header">
      <h4>{{ titulo }}</h4>
    </div>
    <div class="card-body">
      <div class="basic-form">
        <div class="form-row">
          <div class="form-group col-auto">
            <label for="startDate">Data inicial:</label>
            <input
              id="startDate"
              type="date"
              v-model="dataInicio"
              class="form-control"
            />
          </div>
          <div class="form-group col-auto">
            <label for="endDate">Data final:</label>
            <input
              id="endDate"
              type="date"
              v-model="dataFim"
              class="form-control"
            />
          </div>
          <div class="form-group col-md-2 card-header mx-3">
            <button @click="addDates" class="btn btn-primary rounded">
              Adicionar
            </button>
          </div>
        </div>
      </div>
      <ul class="fluid-container">
        <li
          class="fluid-item border"
          v-for="(date, index) in datasSelecionadas"
          :key="index"
        >
          <div class="fluid-container">
            <div class="fluid-item">
              <div class="p-3">
                <strong>{{ formatarData(date) }}</strong>
              </div>
            </div>
            <div class="fluid-item">
              <button
                @click="removeDate(index)"
                class="btn btn-danger btn-sm rounded mx-3"
              >
                Remover
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    indice: {
      type: Number,
      required: false,
      default: 0,
    },
    titulo: {
      type: String,
      required: false,
    },
    datas: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dataInicio: null,
      dataFim: null,
      datasSelecionadas: [],
    };
  },
  methods: {
    formatarData(aDate) {
      return moment(aDate).locale(this.$i18n.locale).format("ll");
    },
    addDates() {
      if (this.dataInicio && this.dataFim) {
        let start = moment(this.dataInicio);
        let end = moment(this.dataFim);

        if (start.isAfter(end)) {
          this.$snackW("A data inicial não pode ser maior que a data final.");
          return;
        }

        let datesToAdd = [];
        while (start.isSameOrBefore(end)) {
          if (!this.datasSelecionadas.includes(start.format("YYYY-MM-DD"))) {
            datesToAdd.push(start.format("YYYY-MM-DD"));
          }
          start.add(1, "day");
        }

        this.datasSelecionadas = [
          ...this.datasSelecionadas,
          ...datesToAdd,
        ].sort();
        this.$emit("atualizar", JSON.stringify(this.datasSelecionadas));
        this.dataInicio = null;
        this.dataFim = null;
      } else {
        this.$snackW("Selecione um intervalo de datas válido.");
      }
    },
    removeDate(index) {
      this.datasSelecionadas.splice(index, 1);
      this.datasSelecionadas.sort();
      this.$emit("atualizar", JSON.stringify(this.datasSelecionadas));
    },
  },
  created() {
    if (this.datas) {
      this.datasSelecionadas = JSON.parse(this.datas);
    }
  },
};
</script>

<style scoped>
.fluid-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color: #fff;
}

.fluid-item {
  flex: 1 1 100px;
  background-color: #fff;
  margin: 0.3rem;
  border-radius: 0.3rem;
  padding: 0.5rem;
}

.border {
  border: 1px solid gray;
}
</style>
